import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    wrapperQuickAddCorporatelView: {
      display: "flex",
      flexDirection: "column",
      gap: "20px",
      padding: "24px",
    },
    headerQuickAddCorporateView: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: theme.spacing(2),
    },
    titleHeaderItem: {
      fontSize: "18px",
      fontWeight: 600,
      lineHeight: "28px",
      color: theme.palette.text.primary,
    },
    containerPercentageTitle: {
      display: "flex",
      gap: "8px",
      alignItems: "center",
    },
    containerItemFiled: {
      display: "flex",
      flexDirection: "row",
      gap: "32px",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
      },
    },
    titleFiledItem: {
      width: "280px",
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "20px",
      color: theme.palette.text.secondary,
    },
    wrapperInputFiled: {
      maxWidth: "512px",
      minWidth: "400px",
      [theme.breakpoints.down("sm")]: {
        maxWidth: "100%",
        minWidth: "100%",
      },
    },
    containerWebsiteFiled: {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      gap: "8px",
    },
    uploadedSection: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      gap: "16px",
    },
    containerUpladedFilesCrads: {
      display: "flex",
      flexDirection: "column",
      gap: "12px",
    },
    CardUploadedFilesInfo: {
      display: "flex",
      flexDirection: "row",
      padding: "16px",
      gap: "12px",
    },
    ContainerFileUploadedInfo: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
    },
    containerTitleAndDeleteIcon: {
      position: "relative",
    },
    DeleteIcon: {
      cursor: "pointer",
      position: "absolute",
      right: "0px",
      top: "0px",
    },
    TitleFileName: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "330px",
      display: "inline-block",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
      color: theme.palette.text.secondary,
    },
    FileSizeTitle: {
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      color: theme.palette.text.tertiary,
    },
  };
});
